<template>
    <div class="table-monitor">
        <table>
            <thead>
                <tr :style="{backgroundColor: tableColor.header}">
                    <column v-for="(column, index) in columns" :key="index" :sort="options.sort.column === index? options.sort.direction : null" :title="column.title" align="center" @click="sort(index)"/>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row, index) in rows" :key="index" :style="{backgroundColor: (index + 1) % 2? tableColor.even : tableColor.odd }">
                    <td v-for="(cell, cellIndex) in row" :style="{textAlign: cellAlign(cellIndex)}" v-html="cell"></td>
                </tr>
            </tbody>
        </table>
        <div class="table-monitor-controls level">
            <limit-selector @select="updateLimit" :value="options.pagination.limit - 1" />
            <pagination
                :current="options.pagination.offset / (options.pagination.limit - 1) + 1"
                :hasNext="payload.length >= options.pagination.limit"
                :hasPrev="!!options.pagination.offset"
                @select="selectPage"
            />
        </div>
    </div>
</template>

<script>
    import LimitSelector from "./components/LimitSelector";
    import Pagination from "./components/Pagination";
    import Column from "./components/Column";

    export default {
        components: {
            'limit-selector': LimitSelector,
            'pagination': Pagination,
            'column': Column
        },
        props: {
            columns: {
                type: Object,
                required: true
            },
            payload: {
                type: Array,
                default() {
                    return [];
                }
            },
            params: {
                type: Object,
                default() {
                    return {};
                }
            },
            color: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                options: {
                    pagination: {
                        limit: 11,
                        offset: 0,
                    },
                    sort: {
                        column: '',
                        direction: 'asc',
                    },
                    ...this.params,
                },
                tableColor: {
                    header: '#A5A5A5',
                    odd: '#E1E1E1',
                    even: '#F0F0F0',
                    ...this.color
                }
            };
        },
        mounted() {
            this.$emit('init', this.options);
        },
        methods: {
            sort(column) {
                if (this.options.sort.column === column) {
                    this.options.sort.direction = this.options.sort.direction === 'asc'? 'desc' : 'asc';
                } else {
                    this.options.sort.column = column;
                    this.options.sort.direction = 'asc';
                    this.options.pagination.offset = 0;
                }
                this.$emit('update', this.options);
            },
            updateLimit(limit) {
                this.options.pagination.limit = +limit + 1;
                this.options.pagination.offset = 0;
                this.$emit('update', this.options);
            },
            selectPage(page) {
                this.options.pagination.offset = (page - 1) * (this.options.pagination.limit - 1);
                this.$emit('update', this.options);
            },
            cellAlign(index) {
                const columns = Object.values(this.columns);
                return columns[index]? columns[index].align : 'left';
            }
        },
        computed: {
            rows() {
                return this.payload.slice(0, this.options.pagination.limit - 1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .table-monitor {
        min-height: 300px;
    }

    th {
        color: #fff;
    }

    td {
        color: #000;
    }

    th, td {
        border: 1px solid #fff;
        padding: 10px;
        font-size: 14px;
    }

    tbody {
        border-top: 5px solid #fff;
    }

    .table-monitor-controls {
        margin-top: 10px;
    }
</style>
